// @flow
import React from 'react';
// Components
import SimpleLogo from '../components/SimpleLogo';
// Styles
import './SimpleHeader.css';
// Images
import logo from '../images/LogoHorizontal.png';

type Props = {
  color: string,
  text: string,
};

const SimpleHeader = ({ color, text }: Props) => {
  return (
    <span className="simple-header-main">
      <SimpleLogo logo={logo} />
    </span>
  );
};

export default SimpleHeader;
